import * as Yup from 'yup'

const postalCodeRegex = (/^(\d{5})(\d{3})$/)

const addressValidator = Yup.object ({
  postal_code: Yup
    .string ()
    .required ('Digite o CEP')
    .test ('validPostalCode', 'Digite um CEP válido', function (value) {
      return postalCodeRegex.test (value)
    }),

  number: Yup
    .string ()
    .required ('Digite o número da residência')
    .max (5, 'O numero deve ter no máximo 5 digitos'),

  complement: Yup.string ()
})

export default addressValidator
